import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fa905826"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "shipping-list" }
const _hoisted_2 = {
  key: 0,
  style: {"color":"#E83D51","margin-left":"20px"}
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_4 = ["innerHTML"]

import { t } from '@/plugins/i18n'
import { ref, Ref, computed, nextTick, toRaw } from 'vue'
import STable from '@/components/Table/index.vue'
import SSearch from './Search.vue'
import ShoppingPreview from '@/components/common/ShoppingPreview.vue'
import Guide from '@/components/guide/index.vue'
import memberEventBox from '@/components/common/MemberEventBox.vue'
import confirmDialog from '@/components/common/ConfirmDialog'

import { editableTabs, planColumns, planChildColumns, tableConfig, planStatusDict } from './data'
import useTabData from '@/util/useTabData'
import { useRtfix, isJA, isMultiStore } from '@/store'
import { shopList, autoOrder } from '@/apis/user'
import { ElMessage, ElMessageBox } from 'element-plus'
import { ReplenishPlanPage, confirmPlan, discardPlan } from '@/apis/inShipping'
import { setNoEmptyForm, getJapanTime, getServiceTime2 } from '@/util/common'
import AppLink from '@/components/common/AppLink.vue'
import { useRoute, useRouter } from 'vue-router'
import BatchSearch from '@/components/BatchSearch/index.vue'
import bus from '@/util/useBus'
import ChooseSetWarehouse from '../components/ChooseSetWarehouse.vue'
import { COUNTRY } from '@/global'
import { request } from '@/config/request/interceptors'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const router = useRouter()
const STableRef = ref()

const refreshTable = (type?: boolean) => {
  if (type) {
    pageData.value = {
      page: 1,
      limit: 30
    }
  }
  nextTick(() => {
    STableRef.value && STableRef.value.getData()
  })
}

const pageData = ref({
  page: 1,
  limit: 30
})

const searchForm: Ref<any> = ref({})

// 消息跳转id=国际发货单号
if (route.query.deliveryTaskCode) {
  searchForm.value.deliveryTaskCode = route.query.deliveryTaskCode
}
const { tabData, planStatus } = useTabData({ TabName: 'planStatus', defaultValue: 'all' }, () => refreshTable(true))
const filterData = computed(() => {
  return {
    ...setNoEmptyForm(toRaw(searchForm.value)),
    planStatus: planStatus.value
  }
})

const shopVisible = ref(false)
const shopData = ref()

const cancel = async (row: any) => {
  row.cancelLoading = true
  try {
    const res = await request.apis.replenishPlan.checkDiscardPlan({ shipmentId: row.shipmentId })
    if (res.success) {
      if (res?.data?.length === 0) {
        const res1 = await discardPlan(row.shipmentId)
        if (res1.success) {
          ElMessage.success(t('作废成功'))
          refreshTable()
        }
      } else {
        ElMessageBox.confirm(`<div>
        <div>${t('如果取消当前补货计划，将会取消以下补货计划，是否确定')}</div>
          <div>
          ${res?.data?.map((item) => {
          return `<div>${item}</div>`
        }).join('')
          }
          </div>
        </div>`, 'ご確認下さい', {
          confirmButtonText: t('确定'),
          cancelButtonText: t('取消'),
          type: 'warning',
          dangerouslyUseHTMLString: true
        }).then(async () => {
          const res1 = await discardPlan(row.shipmentId)
          if (res1.success) {
            ElMessage.success(t('作废成功'))
            refreshTable()
          }
        })
      }
    }
  } catch (error) {
  } finally {
    row.cancelLoading = false
  }
}

let isRequest = false
const submit = (row: any) => {
  if (isRequest) return
  // 超过48小时需要提示不允许提交
  const time = row.createTime
  if (new Date(time).getTime() + 48 * 60 * 60 * 1000 < new Date(getServiceTime2(new Date())).getTime()) {
    confirmDialog({
      title: t('提示'),
      text: t('补货计划已创建超过48h，请取消该条补货计划，并重新创建一条')
    })
    return
  }
  row.confirmLoading = true
  isRequest = true
  confirmPlan(row.shipmentId).then((res: any) => {
    if (res.success) {
      ElMessage.success(t('提交成功'))
      refreshTable()
    }
  }).finally(() => {
    row.confirmLoading = false
    isRequest = false
  })
}

const shopClose = () => {
  shopVisible.value = false
  shopData.value = null
}

const subAccountVisible = ref(false)
const openSubAccountVisible = (id: any) => {
  subAccountVisible.value = true
  selectCustomerShopId.value = id
}

const selectCustomerShopId = ref()
const cancelAuthorizedVisible = ref(false)
const openCancelAuthorizedVisible = (id: any) => {
  cancelAuthorizedVisible.value = true
  selectCustomerShopId.value = id
}

const handleSwitch = (val: any) => {
  val.loading = true
  autoOrder({ customerShopId: val.customerShopId }).then(() => {
    ElMessage.success('修改成功')
  }).finally(() => { val.loading = false })
}

const del = () => {
  console.log('del')
}

const create = () => {
  console.log('create')
}
const batchSearchParams = ref({})
const isBatchSearch = ref(false) // 是否批量搜索
bus.on('batchSearchReplenishmentList', (params: any) => {
  isBatchSearch.value = true
  batchSearchParams.value = params
  refreshTable(true)
})
const search = () => {
  isBatchSearch.value = false
  refreshTable(true)
}
const setVisible = ref(false)
const jumpCreate = () => {
  if (isMultiStore()) {
    setVisible.value = true
    return
  }
  jump(COUNTRY.CN)
}
const jump = (code: string) => {
  router.push(useRtfix('CreateReplenishment', { params: { wareType: code } }))
}

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_table_button = _resolveComponent("table-button")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_tabs, {
      modelValue: _unref(tabData),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(tabData) ? (tabData).value = $event : null)),
      type: "card",
      class: "demo-tabs"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(editableTabs), (item) => {
          return (_openBlock(), _createBlock(_component_el_tab_pane, {
            key: item.name,
            label: item.title,
            name: item.name
          }, null, 8, ["label", "name"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(SSearch, {
      form: searchForm.value,
      "onUpdate:form": _cache[1] || (_cache[1] = ($event: any) => ((searchForm).value = $event)),
      onRefresh: search
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: jumpCreate
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('创建补货计划')), 1)
          ]),
          _: 1
        }),
        (_unref(isJA)())
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(t)('已经API连接完成的店铺，在我司系统制作纳品计划就不需要在亚马逊店铺后台再次制作了。')), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["form"]),
    _createVNode(STable, {
      ref: (_value, _refs) => {
        _refs['STableRef'] = _value
        STableRef.value = _value
      },
      "page-data": pageData.value,
      "onUpdate:page-data": _cache[2] || (_cache[2] = ($event: any) => ((pageData).value = $event)),
      api: _unref(ReplenishPlanPage),
      columns: _unref(planColumns),
      filterData: isBatchSearch.value ? batchSearchParams.value : _unref(filterData),
      tableConfig: _unref(tableConfig)
    }, {
      expand: _withCtx(({ scope }) => [
        _createVNode(STable, {
          "table-data": scope.row.replenishPlanItemList,
          columns: _unref(planChildColumns),
          showPagination: false
        }, {
          productImg: _withCtx(({ row }) => [
            (row.productImg)
              ? (_openBlock(), _createBlock(ShoppingPreview, {
                  key: 0,
                  image: row.productImg || ''
                }, null, 8, ["image"]))
              : _createCommentVNode("", true)
          ]),
          FnskuAsin: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.amazonFnsku ?? '') + " / " + _toDisplayString(row.amazonAsin ?? ''), 1)
          ]),
          productInfo: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.amazonProductTitle ?? '') + " / " + _toDisplayString(row.amazonMsku ?? ''), 1)
          ]),
          productSku: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.productTitle ?? '') + " / " + _toDisplayString(row.productSku ?? ''), 1)
          ]),
          plat: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('Amazon')), 1)
          ]),
          _: 2
        }, 1032, ["table-data", "columns"])
      ]),
      deliveryTaskCode: _withCtx(({ row }) => [
        (row.deliveryTaskCode)
          ? (_openBlock(), _createBlock(AppLink, {
              key: 0,
              to: _unref(useRtfix)('ShippingInfo', { query: { deliveryTaskCode: row.deliveryTaskCode } })
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(row.deliveryTaskCode), 1)
              ]),
              _: 2
            }, 1032, ["to"]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _hoisted_3
            ], 64))
      ]),
      shippingtype: _withCtx(({ row }) => [
        _createTextVNode(_toDisplayString(row.distribution + row.shippingtype + row.forwarder), 1)
      ]),
      createTime: _withCtx(({ row }) => [
        _createTextVNode(_toDisplayString(_unref(getJapanTime)(row.createTime)), 1)
      ]),
      planStatus: _withCtx(({ row }) => [
        _createElementVNode("p", {
          innerHTML: _unref(planStatusDict)[row.planStatus]
        }, null, 8, _hoisted_4)
      ]),
      handler: _withCtx(({ scope }) => [
        (scope.row.planStatus == 1)
          ? (_openBlock(), _createBlock(_component_el_popconfirm, {
              key: 0,
              "popper-class": "pay-pop",
              title: _unref(t)('是否确认提出'),
              onConfirm: ($event: any) => (submit(scope.row))
            }, {
              reference: _withCtx(() => [
                _createVNode(_component_table_button, {
                  title: _unref(t)('提出'),
                  loading: scope.row.confirmLoading
                }, null, 8, ["title", "loading"])
              ]),
              _: 2
            }, 1032, ["title", "onConfirm"]))
          : _createCommentVNode("", true),
        (scope.row.planStatus == 1)
          ? (_openBlock(), _createBlock(_component_el_popconfirm, {
              key: 1,
              "popper-class": "pay-pop",
              title: _unref(t)('是否确认取消'),
              onConfirm: ($event: any) => (cancel(scope.row))
            }, {
              reference: _withCtx(() => [
                _createVNode(_component_table_button, {
                  title: _unref(t)('取消'),
                  loading: scope.row.cancelLoading
                }, null, 8, ["title", "loading"])
              ]),
              _: 2
            }, 1032, ["title", "onConfirm"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["page-data", "api", "columns", "filterData", "tableConfig"]),
    _createVNode(Guide, { name: "replenishment-list" }),
    _createVNode(BatchSearch, { title: "ReplenishmentList" }),
    _createVNode(ChooseSetWarehouse, {
      visible: setVisible.value,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((setVisible).value = $event)),
      onSuccess: jump
    }, null, 8, ["visible"])
  ]))
}
}

})